import { useCallback } from 'react'
import { BaseButtonModalSortListProps } from '../../../../../../../baseComponents/Sorts/ButtonModalSortList/types'
import ButtonModalSortList, { ItemSortFunction } from '../../../../../../../baseComponents/Sorts/ButtonModalSortList'
import { twinFetchPostText } from '../../../../../../../utils/globals/data'

interface ConfigBillingTypeSellSortButtonProps extends BaseButtonModalSortListProps {
}

const ConfigBillingTypeSellSortButton: React.FC<ConfigBillingTypeSellSortButtonProps> = ({ ...rest }) => {
    const { updateOrder } = useConfigBillingTypeSellSortButtonLogic()
    return (
        <ButtonModalSortList updateData={updateOrder} getDataFrom='/api/app/config/billingGroup/billingTypeSell/getAllBillingTypesSell' {...rest} />
    )
}

const useConfigBillingTypeSellSortButtonLogic = () => {
    const updateOrder: ItemSortFunction = useCallback(async (data) => {
        const resp = await twinFetchPostText('/api/app/config/billingGroup/billingTypeSell/updateBillingTypesSellOrder', { billingTypesSell: data })
        if (resp) {
            return true
        }
        return false
    }, [])

    return { updateOrder }
}

export default ConfigBillingTypeSellSortButton